module.exports = __webpack_public_path__ + "img/5.2b0d846e.svg";